/* FERRY AUTO-GENERATED: DO NOT EDIT THIS FILE */ /* eslint-disable */ // @ts-nocheck
import * as video from "../../common/video";
import * as image from "../../common/image";
export { video, image };
export var InvitationBrandVideoPlatformAuditViolationType = {
  BrandVideo_ViolationType_TNS: 1,
  BrandVideo_ViolationType_BI: 2,
  BrandVideo_ViolationType_GNE: 3,
  BrandVideo_ViolationType_Unknown: 99
};
export var InvitationBrandVideoSellerAuditReasonType = {
  BrandVideo_NotFitMessage: 1,
  BrandVideo_QualityIssue: 2,
  BrandVideo_LegalIssue: 3,
  BrandVideo_Other: 4
};
export var BrandVideoStatus = {
  BrandVideoStatus_Init: 0,
  BrandVideoStatus_PlatformAuditing: 1,
  BrandVideoStatus_PlatformAuditFail: 2,
  BrandVideoStatus_PlatformAuditTimeOut: 3,
  BrandVideoStatus_PlatformAppealing: 10,
  BrandVideoStatus_SellerAuditing: 20,
  BrandVideoStatus_SellerAuditingFailed: 21,
  BrandVideoStatus_AuditPass: 30,
  BrandVideoStatus_PubliclyVisible: 40
};